import { configureStore } from '@reduxjs/toolkit'
import intervalSlice from './store/reduxStore'

const store = configureStore({
  reducer: {
    interval: intervalSlice,
  },
})

export default store